// src/components/learning/islamic/suratesData.js
// Les sourates courtes du Coran - Contenu éducatif pour enfants

export const suratesData = [
  {
    id: 1,
    number: 1,
    name: "Al-Fatiha",
    nameAr: "الفَاتِحَة",
    meaning: "L'Ouverture",
    versesCount: 7,
    level: "beginner",
    icon: "📖",
    color: "#8b5cf6",
    gradient: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
    audioFile: "/audio/surates/al-fatiha.mp3",
    
    intro: "Al-Fatiha est la première sourate du Coran. On la récite dans chaque prière. C'est la sourate la plus importante !",
    
    context: "Cette sourate est appelée 'Oum Al-Kitab' (la Mère du Livre) car elle résume tout le message du Coran.",
    
    verses: [
      {
        number: 1,
        arabic: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
        transliteration: "Bismillahi ar-rahmani ar-rahim",
        translation: "Au nom d'Allah, le Tout Miséricordieux, le Très Miséricordieux"
      },
      {
        number: 2,
        arabic: "الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ",
        transliteration: "Al-hamdu lillahi rabbi al-'alamin",
        translation: "Louange à Allah, Seigneur des mondes"
      },
      {
        number: 3,
        arabic: "الرَّحْمَٰنِ الرَّحِيمِ",
        transliteration: "Ar-rahmani ar-rahim",
        translation: "Le Tout Miséricordieux, le Très Miséricordieux"
      },
      {
        number: 4,
        arabic: "مَالِكِ يَوْمِ الدِّينِ",
        transliteration: "Maliki yawmi ad-din",
        translation: "Maître du Jour du Jugement"
      },
      {
        number: 5,
        arabic: "إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ",
        transliteration: "Iyyaka na'budu wa iyyaka nasta'in",
        translation: "C'est Toi seul que nous adorons, et c'est Toi seul dont nous implorons le secours"
      },
      {
        number: 6,
        arabic: "اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ",
        transliteration: "Ihdina as-sirata al-mustaqim",
        translation: "Guide-nous dans le droit chemin"
      },
      {
        number: 7,
        arabic: "صِرَاطَ الَّذِينَ أَنْعَمْتَ عَلَيْهِمْ غَيْرِ الْمَغْضُوبِ عَلَيْهِمْ وَلَا الضَّالِّينَ",
        transliteration: "Sirata alladhina an'amta 'alayhim ghayri al-maghdubi 'alayhim wa la ad-dallin",
        translation: "Le chemin de ceux que Tu as comblés de bienfaits, non pas de ceux qui ont encouru Ta colère, ni des égarés"
      }
    ],
    
    funFacts: [
      "🤲 On récite Al-Fatiha au moins 17 fois par jour dans les prières !",
      "📚 Elle s'appelle aussi 'As-Sab' Al-Mathani' (les 7 versets répétés)",
      "💎 Le Prophète ﷺ a dit qu'elle est la plus grande sourate du Coran"
    ],
    
    quiz: [
      {
        question: "Combien de versets a la sourate Al-Fatiha ?",
        options: ["5", "6", "7", "8"],
        correct: "7"
      },
      {
        question: "Que signifie 'Al-Fatiha' ?",
        options: ["La Fin", "L'Ouverture", "Le Milieu", "La Lumière"],
        correct: "L'Ouverture"
      }
    ]
  },

  {
    id: 2,
    number: 112,
    name: "Al-Ikhlas",
    nameAr: "الإِخْلَاص",
    meaning: "Le Monothéisme Pur",
    versesCount: 4,
    level: "beginner",
    icon: "☝️",
    color: "#3b82f6",
    gradient: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
    audioFile: "/audio/surates/al-ikhlas.mp3",
    
    intro: "Al-Ikhlas nous enseigne qui est Allah. Elle équivaut à un tiers du Coran !",
    
    context: "Quand les polythéistes ont demandé au Prophète ﷺ de décrire Allah, cette sourate a été révélée.",
    
    verses: [
      {
        number: 1,
        arabic: "قُلْ هُوَ اللَّهُ أَحَدٌ",
        transliteration: "Qul huwa Allahu ahad",
        translation: "Dis : Il est Allah, l'Unique"
      },
      {
        number: 2,
        arabic: "اللَّهُ الصَّمَدُ",
        transliteration: "Allahu as-samad",
        translation: "Allah, le Seul à être imploré pour ce que nous désirons"
      },
      {
        number: 3,
        arabic: "لَمْ يَلِدْ وَلَمْ يُولَدْ",
        transliteration: "Lam yalid wa lam yulad",
        translation: "Il n'a jamais engendré, et n'a pas été engendré"
      },
      {
        number: 4,
        arabic: "وَلَمْ يَكُن لَّهُ كُفُوًا أَحَدٌ",
        transliteration: "Wa lam yakun lahu kufuwan ahad",
        translation: "Et nul n'est égal à Lui"
      }
    ],
    
    funFacts: [
      "⭐ La réciter équivaut à réciter un tiers du Coran !",
      "💫 Le Prophète ﷺ l'aimait beaucoup",
      "🛡️ Elle est une protection contre le mal"
    ],
    
    quiz: [
      {
        question: "Que signifie 'Ahad' ?",
        options: ["Deux", "Unique", "Plusieurs", "Grand"],
        correct: "Unique"
      },
      {
        question: "À combien du Coran équivaut cette sourate ?",
        options: ["1/2", "1/3", "1/4", "1/5"],
        correct: "1/3"
      }
    ]
  },

  {
    id: 3,
    number: 113,
    name: "Al-Falaq",
    nameAr: "الفَلَق",
    meaning: "L'Aube Naissante",
    versesCount: 5,
    level: "beginner",
    icon: "🌅",
    color: "#f59e0b",
    gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
    audioFile: "/audio/surates/al-falaq.mp3",
    
    intro: "Al-Falaq est une sourate de protection. On demande à Allah de nous protéger du mal.",
    
    context: "Cette sourate et An-Nas sont appelées 'Al-Mu'awwidhatain' (les deux protectrices). Le Prophète ﷺ les récitait chaque nuit.",
    
    verses: [
      {
        number: 1,
        arabic: "قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ",
        transliteration: "Qul a'udhu bi rabbi al-falaq",
        translation: "Dis : Je cherche protection auprès du Seigneur de l'aube naissante"
      },
      {
        number: 2,
        arabic: "مِن شَرِّ مَا خَلَقَ",
        transliteration: "Min sharri ma khalaq",
        translation: "Contre le mal de ce qu'Il a créé"
      },
      {
        number: 3,
        arabic: "وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ",
        transliteration: "Wa min sharri ghasiqin idha waqab",
        translation: "Contre le mal de l'obscurité quand elle s'approfondit"
      },
      {
        number: 4,
        arabic: "وَمِن شَرِّ النَّفَّاثَاتِ فِي الْعُقَدِ",
        transliteration: "Wa min sharri an-naffathati fi al-'uqad",
        translation: "Contre le mal de celles qui soufflent sur les nœuds"
      },
      {
        number: 5,
        arabic: "وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ",
        transliteration: "Wa min sharri hasidin idha hasad",
        translation: "Et contre le mal de l'envieux quand il envie"
      }
    ],
    
    funFacts: [
      "🌙 Le Prophète ﷺ la récitait avant de dormir",
      "🛡️ Elle protège contre le mauvais œil",
      "👫 Avec An-Nas, elles forment les 'Deux Protectrices'"
    ],
    
    quiz: [
      {
        question: "Que signifie 'Al-Falaq' ?",
        options: ["La Nuit", "L'Aube", "Le Soleil", "La Lune"],
        correct: "L'Aube"
      },
      {
        question: "Contre quoi cette sourate nous protège-t-elle ?",
        options: ["Le bien", "Le mal", "La joie", "La richesse"],
        correct: "Le mal"
      }
    ]
  },

  {
    id: 4,
    number: 114,
    name: "An-Nas",
    nameAr: "النَّاس",
    meaning: "Les Hommes",
    versesCount: 6,
    level: "beginner",
    icon: "👥",
    color: "#10b981",
    gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    audioFile: "/audio/surates/an-nas.mp3",
    
    intro: "An-Nas est la dernière sourate du Coran. Elle nous apprend à chercher protection auprès d'Allah contre les mauvaises pensées.",
    
    context: "Cette sourate nous protège contre les chuchotements de Shaytan (le diable) qui essaie de nous éloigner du bien.",
    
    verses: [
      {
        number: 1,
        arabic: "قُلْ أَعُوذُ بِرَبِّ النَّاسِ",
        transliteration: "Qul a'udhu bi rabbi an-nas",
        translation: "Dis : Je cherche protection auprès du Seigneur des hommes"
      },
      {
        number: 2,
        arabic: "مَلِكِ النَّاسِ",
        transliteration: "Maliki an-nas",
        translation: "Le Souverain des hommes"
      },
      {
        number: 3,
        arabic: "إِلَٰهِ النَّاسِ",
        transliteration: "Ilahi an-nas",
        translation: "Le Dieu des hommes"
      },
      {
        number: 4,
        arabic: "مِن شَرِّ الْوَسْوَاسِ الْخَنَّاسِ",
        transliteration: "Min sharri al-waswasi al-khannas",
        translation: "Contre le mal du mauvais conseiller, furtif"
      },
      {
        number: 5,
        arabic: "الَّذِي يُوَسْوِسُ فِي صُدُورِ النَّاسِ",
        transliteration: "Alladhi yuwaswisu fi suduri an-nas",
        translation: "Qui souffle le mal dans les poitrines des hommes"
      },
      {
        number: 6,
        arabic: "مِنَ الْجِنَّةِ وَالنَّاسِ",
        transliteration: "Mina al-jinnati wa an-nas",
        translation: "Qu'il soit djinn ou humain"
      }
    ],
    
    funFacts: [
      "📖 C'est la dernière sourate du Coran (114ème)",
      "🛡️ Elle protège contre les mauvaises pensées",
      "🤲 Le Prophète ﷺ la récitait avec Al-Falaq pour se protéger"
    ],
    
    quiz: [
      {
        question: "Quelle est la position d'An-Nas dans le Coran ?",
        options: ["Première", "Dernière", "Au milieu", "113ème"],
        correct: "Dernière"
      },
      {
        question: "Contre qui cette sourate nous protège-t-elle ?",
        options: ["Les anges", "Le Waswas (chuchoteur)", "Les animaux", "Les plantes"],
        correct: "Le Waswas (chuchoteur)"
      }
    ]
  },

  {
    id: 5,
    number: 108,
    name: "Al-Kawthar",
    nameAr: "الكَوْثَر",
    meaning: "L'Abondance",
    versesCount: 3,
    level: "beginner",
    icon: "💧",
    color: "#06b6d4",
    gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
    audioFile: "/audio/surates/al-kawthar.mp3",
    
    intro: "Al-Kawthar est la plus courte sourate du Coran avec seulement 3 versets. 'Al-Kawthar' est une rivière au Paradis !",
    
    context: "Cette sourate a été révélée pour consoler le Prophète ﷺ quand ses ennemis se moquaient de lui après la mort de son fils.",
    
    verses: [
      {
        number: 1,
        arabic: "إِنَّا أَعْطَيْنَاكَ الْكَوْثَرَ",
        transliteration: "Inna a'taynaka al-kawthar",
        translation: "Nous t'avons certes accordé l'Abondance"
      },
      {
        number: 2,
        arabic: "فَصَلِّ لِرَبِّكَ وَانْحَرْ",
        transliteration: "Fasalli li rabbika wanhar",
        translation: "Accomplis la prière pour ton Seigneur et sacrifie"
      },
      {
        number: 3,
        arabic: "إِنَّ شَانِئَكَ هُوَ الْأَبْتَرُ",
        transliteration: "Inna shani'aka huwa al-abtar",
        translation: "Certes, celui qui te hait sera lui-même privé de postérité"
      }
    ],
    
    funFacts: [
      "📏 C'est la plus courte sourate du Coran !",
      "🏞️ Al-Kawthar est une rivière au Paradis plus blanche que le lait",
      "💎 Ses rives sont en perles et rubis"
    ],
    
    quiz: [
      {
        question: "Combien de versets a la sourate Al-Kawthar ?",
        options: ["2", "3", "4", "5"],
        correct: "3"
      },
      {
        question: "Qu'est-ce que Al-Kawthar ?",
        options: ["Une montagne", "Une rivière au Paradis", "Un ange", "Une étoile"],
        correct: "Une rivière au Paradis"
      }
    ]
  },

  {
    id: 6,
    number: 103,
    name: "Al-Asr",
    nameAr: "العَصْر",
    meaning: "Le Temps",
    versesCount: 3,
    level: "intermediate",
    icon: "⏰",
    color: "#ec4899",
    gradient: "linear-gradient(135deg, #ec4899 0%, #be185d 100%)",
    audioFile: "/audio/surates/al-asr.mp3",
    
    intro: "Al-Asr nous rappelle l'importance du temps. Allah jure par le temps pour nous montrer sa valeur !",
    
    context: "L'Imam Shafi'i a dit : 'Si les gens méditaient sur cette sourate, elle leur suffirait.' Elle contient un message essentiel.",
    
    verses: [
      {
        number: 1,
        arabic: "وَالْعَصْرِ",
        transliteration: "Wal-'asr",
        translation: "Par le Temps !"
      },
      {
        number: 2,
        arabic: "إِنَّ الْإِنسَانَ لَفِي خُسْرٍ",
        transliteration: "Inna al-insana lafi khusr",
        translation: "L'homme est certes en perdition"
      },
      {
        number: 3,
        arabic: "إِلَّا الَّذِينَ آمَنُوا وَعَمِلُوا الصَّالِحَاتِ وَتَوَاصَوْا بِالْحَقِّ وَتَوَاصَوْا بِالصَّبْرِ",
        transliteration: "Illa alladhina amanu wa 'amilu as-salihati wa tawasaw bil-haqqi wa tawasaw bis-sabr",
        translation: "Sauf ceux qui croient, font le bien, s'encouragent à la vérité et s'encouragent à la patience"
      }
    ],
    
    funFacts: [
      "⏳ Allah jure par le temps pour montrer son importance",
      "📜 Cette sourate résume comment réussir dans la vie",
      "🤝 Les compagnons se récitaient cette sourate avant de se quitter"
    ],
    
    quiz: [
      {
        question: "Par quoi Allah jure-t-il dans cette sourate ?",
        options: ["Le soleil", "Le temps", "La lune", "Les étoiles"],
        correct: "Le temps"
      },
      {
        question: "Qui n'est PAS en perdition selon cette sourate ?",
        options: ["Tout le monde", "Ceux qui croient et font le bien", "Les riches", "Les savants"],
        correct: "Ceux qui croient et font le bien"
      }
    ]
  },

  {
    id: 7,
    number: 105,
    name: "Al-Fil",
    nameAr: "الفِيل",
    meaning: "L'Éléphant",
    versesCount: 5,
    level: "intermediate",
    icon: "🐘",
    color: "#6366f1",
    gradient: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
    audioFile: "/audio/surates/al-fil.mp3",
    
    intro: "Cette sourate raconte l'histoire incroyable de l'armée aux éléphants qui a voulu détruire la Kaaba !",
    
    context: "L'année où le Prophète ﷺ est né, Abraha est venu avec une armée d'éléphants pour détruire la Kaaba. Allah a envoyé des oiseaux pour les arrêter !",
    
    verses: [
      {
        number: 1,
        arabic: "أَلَمْ تَرَ كَيْفَ فَعَلَ رَبُّكَ بِأَصْحَابِ الْفِيلِ",
        transliteration: "Alam tara kayfa fa'ala rabbuka bi ashabi al-fil",
        translation: "N'as-tu pas vu comment ton Seigneur a agi envers les gens de l'Éléphant ?"
      },
      {
        number: 2,
        arabic: "أَلَمْ يَجْعَلْ كَيْدَهُمْ فِي تَضْلِيلٍ",
        transliteration: "Alam yaj'al kaydahum fi tadlil",
        translation: "N'a-t-Il pas rendu leur ruse complètement vaine ?"
      },
      {
        number: 3,
        arabic: "وَأَرْسَلَ عَلَيْهِمْ طَيْرًا أَبَابِيلَ",
        transliteration: "Wa arsala 'alayhim tayran ababil",
        translation: "Et Il envoya sur eux des oiseaux par vagues successives"
      },
      {
        number: 4,
        arabic: "تَرْمِيهِم بِحِجَارَةٍ مِّن سِجِّيلٍ",
        transliteration: "Tarmihim bi hijaratin min sijjil",
        translation: "Qui leur lançaient des pierres d'argile"
      },
      {
        number: 5,
        arabic: "فَجَعَلَهُمْ كَعَصْفٍ مَّأْكُولٍ",
        transliteration: "Faja'alahum ka'asfin ma'kul",
        translation: "Et Il les rendit semblables à de la paille mâchée"
      }
    ],
    
    funFacts: [
      "🐘 Abraha avait un grand éléphant nommé Mahmoud",
      "🐦 Allah a envoyé des milliers d'oiseaux Ababil",
      "👶 C'est l'année où le Prophète ﷺ est né !"
    ],
    
    quiz: [
      {
        question: "Qui a voulu détruire la Kaaba ?",
        options: ["Pharaon", "Abraha", "Namroud", "Abu Lahab"],
        correct: "Abraha"
      },
      {
        question: "Qu'est-ce qu'Allah a envoyé pour les arrêter ?",
        options: ["Des lions", "Des oiseaux", "La pluie", "Le vent"],
        correct: "Des oiseaux"
      }
    ]
  },

  {
    id: 8,
    number: 111,
    name: "Al-Massad",
    nameAr: "المَسَد",
    meaning: "Les Fibres",
    versesCount: 5,
    level: "intermediate",
    icon: "🔥",
    color: "#ef4444",
    gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
    audioFile: "/audio/surates/al-massad.mp3",
    
    intro: "Cette sourate parle d'Abu Lahab, l'oncle du Prophète ﷺ qui était son pire ennemi et le persécutait.",
    
    context: "Abu Lahab et sa femme faisaient tout pour nuire au Prophète ﷺ. Sa femme mettait des épines sur son chemin.",
    
    verses: [
      {
        number: 1,
        arabic: "تَبَّتْ يَدَا أَبِي لَهَبٍ وَتَبَّ",
        transliteration: "Tabbat yada abi lahabin wa tabb",
        translation: "Que périssent les deux mains d'Abu Lahab et que lui-même périsse"
      },
      {
        number: 2,
        arabic: "مَا أَغْنَىٰ عَنْهُ مَالُهُ وَمَا كَسَبَ",
        transliteration: "Ma aghna 'anhu maluhu wa ma kasab",
        translation: "Sa fortune ne lui sert à rien, ni ce qu'il a acquis"
      },
      {
        number: 3,
        arabic: "سَيَصْلَىٰ نَارًا ذَاتَ لَهَبٍ",
        transliteration: "Sayasla naran dhata lahab",
        translation: "Il sera brûlé dans un Feu plein de flammes"
      },
      {
        number: 4,
        arabic: "وَامْرَأَتُهُ حَمَّالَةَ الْحَطَبِ",
        transliteration: "Wamra'atuhu hammalata al-hatab",
        translation: "Ainsi que sa femme, la porteuse de bois"
      },
      {
        number: 5,
        arabic: "فِي جِيدِهَا حَبْلٌ مِّن مَّسَدٍ",
        transliteration: "Fi jidiha hablun min masad",
        translation: "À son cou une corde de fibres"
      }
    ],
    
    funFacts: [
      "👤 Abu Lahab signifie 'père de la flamme'",
      "📜 C'est la seule sourate qui nomme une personne ennemie de l'Islam",
      "⚡ Cette prophétie s'est réalisée : Abu Lahab est mort mécréant"
    ],
    
    quiz: [
      {
        question: "Qui était Abu Lahab pour le Prophète ﷺ ?",
        options: ["Son frère", "Son oncle", "Son cousin", "Son voisin"],
        correct: "Son oncle"
      },
      {
        question: "Que faisait la femme d'Abu Lahab ?",
        options: ["Elle aidait le Prophète", "Elle mettait des épines sur son chemin", "Elle lui donnait à manger", "Elle le protégeait"],
        correct: "Elle mettait des épines sur son chemin"
      }
    ]
  },

  {
    id: 9,
    number: 110,
    name: "An-Nasr",
    nameAr: "النَّصْر",
    meaning: "Le Secours",
    versesCount: 3,
    level: "intermediate",
    icon: "🏆",
    color: "#22c55e",
    gradient: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
    audioFile: "/audio/surates/an-nasr.mp3",
    
    intro: "An-Nasr annonce la victoire de l'Islam et la conquête de La Mecque. C'est l'une des dernières sourates révélées.",
    
    context: "Cette sourate a été révélée peu avant la mort du Prophète ﷺ. Elle annonçait que sa mission était accomplie.",
    
    verses: [
      {
        number: 1,
        arabic: "إِذَا جَاءَ نَصْرُ اللَّهِ وَالْفَتْحُ",
        transliteration: "Idha ja'a nasru Allahi wal-fath",
        translation: "Lorsque vient le secours d'Allah ainsi que la victoire"
      },
      {
        number: 2,
        arabic: "وَرَأَيْتَ النَّاسَ يَدْخُلُونَ فِي دِينِ اللَّهِ أَفْوَاجًا",
        transliteration: "Wa ra'ayta an-nasa yadkhuluna fi dini Allahi afwaja",
        translation: "Et que tu vois les gens entrer en foule dans la religion d'Allah"
      },
      {
        number: 3,
        arabic: "فَسَبِّحْ بِحَمْدِ رَبِّكَ وَاسْتَغْفِرْهُ ۚ إِنَّهُ كَانَ تَوَّابًا",
        transliteration: "Fasabbih bi hamdi rabbika wastaghfirhu innahu kana tawwaba",
        translation: "Alors glorifie ton Seigneur et implore Son pardon. Car c'est Lui le grand Accueillant au repentir"
      }
    ],
    
    funFacts: [
      "🏆 Cette sourate annonce la conquête de La Mecque",
      "📖 C'est l'une des dernières sourates révélées",
      "👥 Après cette sourate, des milliers de personnes sont devenues musulmanes"
    ],
    
    quiz: [
      {
        question: "Que signifie 'An-Nasr' ?",
        options: ["La défaite", "Le secours/victoire", "La tristesse", "La peur"],
        correct: "Le secours/victoire"
      },
      {
        question: "Quel événement cette sourate annonce-t-elle ?",
        options: ["La naissance du Prophète", "La conquête de La Mecque", "L'Hégire", "La bataille de Badr"],
        correct: "La conquête de La Mecque"
      }
    ]
  }
];

// Messages d'encouragement
export const surateEncouragements = {
  correct: [
    "🌟 Mashallah ! Tu connais bien !",
    "⭐ Excellent ! Barakallahu fik !",
    "🎉 Bravo ! Continue comme ça !",
    "💫 Super ! Allah est fier de toi !"
  ],
  wrong: [
    "💪 Ce n'est pas grave, réessaie !",
    "📖 Relis la sourate et réessaie !",
    "🤲 Avec de la pratique, tu y arriveras !"
  ],
  memorized: [
    "🏆 Félicitations ! Tu as mémorisé cette sourate !",
    "🌟 Mashallah ! Continue à réviser !",
    "⭐ Tu es sur le chemin du Hafidh !"
  ]
};

// Badges par sourate
export const surateBadges = {
  "Al-Fatiha": { icon: "📖", name: "Clé du Coran" },
  "Al-Ikhlas": { icon: "☝️", name: "Tawhid" },
  "Al-Falaq": { icon: "🛡️", name: "Protégé" },
  "An-Nas": { icon: "🤲", name: "Refuge" },
  "Al-Kawthar": { icon: "💧", name: "Abondance" },
  "Al-Asr": { icon: "⏰", name: "Sage" },
  "Al-Fil": { icon: "🐘", name: "Historien" },
  "Al-Massad": { icon: "📜", name: "Averti" },
  "An-Nasr": { icon: "🏆", name: "Victorieux" }
};

export default suratesData;
